


































































import { useWorkFlow } from '../composables/useWorkFlow';
import { computed, defineComponent } from '@vue/composition-api';

export const DefaultBgColors: Record<'lines' | 'dots', string> = {
  dots: '#81818a',
  lines: '#eee'
};
export default defineComponent({
  name: 'WorkflowBackground',

  props: {
    id: Number,

    gap: {
      type: Number,
      default: 20
    },
    size: {
      type: Number,
      default: 1
    },
    lineWidth: {
      type: Number,
      default: 1
    },

    x: {
      type: Number,
      default: 0
    },
    y: {
      type: Number,
      default: 0
    },

    backgroundColor: {
      type: String,
      default: ''
    },

    color: {
      type: String,
      default: '#81818a'
    },

    offset: {
      type: [Number, Array],
      default: 0
    }
  },

  computed: {},

  setup(props) {
    const { id: workflowId, viewport } = useWorkFlow();

    const background = computed(() => {
      const zoom = viewport.value.zoom;
      const [gapX, gapY] = Array.isArray(props.gap)
        ? props.gap
        : [props.gap, props.gap];
      const scaledGap: [number, number] = [gapX * zoom || 1, gapY * zoom || 1];
      const scaledSize = props.size * zoom;
      const [offsetX, offsetY]: [number, number] = Array.isArray(props.offset)
        ? (props.offset as [number, number])
        : [props.offset, props.offset];

      const scaledOffset: [number, number] = [
        offsetX * zoom || 1 + scaledGap[0] / 2,
        offsetY * zoom || 1 + scaledGap[1] / 2
      ];

      return {
        scaledGap,
        offset: scaledOffset,
        size: scaledSize
      };
    });

    // when there are multiple flows on a page we need to make sure that every background gets its own pattern.
    const patternId = computed(
      () => `pattern-${workflowId}${props.id ? `-${props.id}` : ''}`
    );

    const patternColor = computed(() => props.color);

    return {
      background,
      patternId,
      patternColor,
      viewport
    };
  }
});
